import { BaseRequest } from "./baseRequest";

export class ConfDocumentRequest extends BaseRequest {
  confSessionId?: number;
  configurationId?: number;
  documentId?: number;
}